import { structure } from '@dofleini/location';
import { Select } from 'antd';
import compose from 'lodash/fp/compose';
import filter from 'lodash/fp/filter';
import map from 'lodash/fp/map';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';

import { useSelectSearchProps } from '../hooks';

const { PROVINCES } = structure;

const ProvincesField = ({ value, filterBy, ...props }) => {
  const options = useMemo(
    () =>
      compose(
        map(({ name, acronym }) => ({ label: name, value: acronym })),
        filter(({ acronym }) => (!filterBy || isEmpty(filterBy)) || includes(filterBy, acronym)),
      )(PROVINCES),
    [filterBy]
  );
  
  const _props = useSelectSearchProps(options, value);
  
  return (
    <Select allowClear value={value} {..._props} {...props} />
  );
};

ProvincesField.propTypes = {
  value: PropTypes.any,
  filterBy: PropTypes.array
};

export default memo(ProvincesField);
